import { makeStyles } from '@material-ui/core';
import oneLoopAiLogo from '../../assets/oneloopai-logo.svg';

const useStyles = makeStyles({
  svg: {
    height: 28,
    width: 'auto',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img className={classes.svg} src={oneLoopAiLogo} alt="HTEC OneLoopAi" />
  );
};

export default LogoIcon;
